import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import { STAGES } from '@/constants/delta2max';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import { youtubeMap } from '@/constants/delta2max';

export default function A({ stage }: any) {
    const { useLang, useState, gtm, useRouter } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const SHOW_YOUTUBE: boolean = [STAGES.CROWDFUNDING, STAGES.DETAIL].includes(stage);

    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const playerVideo = () => {
        setShowEFVideoModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 Max | UX video',
            position: SHOW_YOUTUBE ? 'Product Crowdfunding_1' : 'Product_1',
            __btn_id1: css.d2xDetailA,
            __btn_id2: t('sec1_watch'),
        });
    };

    return (
        <div className={`d2x-teaser-A ${css.d2xTeaserA} GtmModuleData-section`} data-section-id={css.d2xTeaserA} data-section-title={t('sec1_title')}>
            <div className="img-wrapper">
                <NextImage
                    webpSrc={require(`@publicLocal/delta2max/teaser/h5/${locale}/kv.webp`)}
                    src={require(`@publicLocal/delta2max/teaser/h5/${locale}/kv.jpg`)}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
                {/* <div className="reddot">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/reddot.webp')}
                        src={require('@publicLocal/delta2max/reddot.png')}
                        alt={t('sec1_title')}
                        aria-label={t('sec1_title')}
                    />
                </div> */}
            </div>
            <div className="text-wrapper">
                <p className="title">{t('sec1_title')}</p>
                <p className="desc">{stage === STAGES.TEASER ? t('sec1_desc') : t('sec1_product')}</p>
                {SHOW_YOUTUBE && (
                    <div className="video-btn GtmModuleData-btn-text" onClick={playerVideo}>
                        <p>{t('sec1_watch')}</p>
                        <div className="video-icon">
                            <EFDelta2VideoPlayer />
                        </div>
                    </div>
                )}
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={youtubeMap[locale] || youtubeMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
